import { CTA_COLORS } from './common/types';

export const getCTAStyles = (variant: CTA_COLORS) => {
  const classNames = () => {
    switch (variant) {
      case 'indigo':
        return {
          bgColor: `bg-indigo`,
          textColor: 'text-white',
        };

      case 'deep_blue':
        return {
          bgColor: 'bg-blue-deep',
          borderColor: 'border-blue-deep',
          textColor: 'text-white',
          states:
            'hover:bg-[#131C66] hover:border-[#131C66] active:bg-[#131C66] active:border-[#131C66]',
        };

      case 'dark_gray':
        return {
          bgColor: 'bg-grey-dark',
          borderColor: 'border-grey-dark',
          textColor: 'text-white',
          states:
            'hover:bg-[#313130] hover:border-[#313130] active:bg-[#313130] active:border-[#313130]',
        };

      case 'lime_green':
        return {
          bgColor: 'bg-lime-green',
          borderColor: 'border-lime-green',
          textColor: 'text-[#454343]',
          states:
            'hover:bg-[#ADCB03] hover:border-[#ADCB03] active:bg-[#ADCB03] active:border-[#ADCB03]',
        };
      case 'yellow':
        return {
          bgColor: 'bg-yellow',
          borderColor: 'border-yellow',
          textColor: 'text-grey-dark',
          states:
            'hover:bg-[#E7C702] hover:border-[#E7C702] active:bg-[#E7C702] active:border-[#E7C702]',
        };

      case 'red_v2':
        return {
          bgColor: 'bg-red-v2',
          borderColor: 'border-red-v2',
          textColor: 'text-white',
          states:
            'hover:bg-red-v2-hover hover:border-red-v2-hover active:bg-red-v2-hover active:border-red-v2-hover',
        };
      default:
        return {
          bgColor: `bg-indigo`,
          textColor: 'text-white',
        };
    }
  };

  return Object.values(classNames()).join(' ');
};

export const getCtaTextStyles = (variant = CTA_COLORS.DEFAULT) => {
  const classNames = () => {
    switch (variant) {
      case 'indigo':
        return {
          textColor: 'text-indigo',
        };

      case 'deep_blue':
        return {
          textColor: 'text-blue-deep',
          states: 'hover:text-[#131C66] active:text-[#131C66]',
        };

      case 'dark_gray':
        return {
          textColor: 'text-grey-dark',
          states: 'hover:text-[#313130] active:text-[#313130]',
        };

      case 'lime_green':
        return {
          textColor: 'text-lime-green',
          states: 'hover:text-[#ADCB03] active:text-[#ADCB03]',
        };

      case 'yellow':
        return {
          textColor: 'text-yellow',
          states: 'hover:text-[#E7C702] active:text-[#E7C702]',
        };

      default:
        return {
          textColor: 'text-indigo',
        };
    }
  };

  return Object.values(classNames()).join(' ');
};
